// Local
import { DbRead } from "../../database";

/** Checks if the given site has the compliance feature enabled. */
export async function isComplianceEnabled(siteKey: string): Promise<boolean> {
  const siteKeyDoc = await DbRead.siteKey.get(siteKey);
  return siteKeyDoc.customizations.compliance === true;
}
